'use strict';

/**
 * Check if a date is a valid belgian formatted date, and sensible as a birthdate.
 * It will parse to a moment in the backend.
 */
customerZone.directive('validateBirthdate', [function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var invalid = function(key){
                ctrl.$setValidity(key || 'birthdate', false);
                return undefined;
            };
            ctrl.$parsers.push(function(value){
                var minYears = scope.$eval(attrs['minYears']);
                ctrl.$setValidity('birthdate', true);
                ctrl.$setValidity('birthdate_range', true);
                if (value === '') return '';
                else {
                    var parsed;
                    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.exec(value))
                        parsed = moment(value, 'DD/MM/YYYY');
                    else if (/^\d{1,2}-\d{1,2}-\d{4}$/.exec(value))
                        parsed = moment(value, 'DD-MM-YYYY');
                    else if (/^\d{4}-\d{1,2}-\d{1,2}$/.exec(value))
                        parsed = moment(value, 'YYYY-MM-DD');
                    else
                        return invalid();

                    if (!parsed.isValid())
                        return invalid();

                    if (parsed.isAfter(moment().subtract(minYears, 'years'))) {
                        return invalid('birthdate_range');
                    }
                    if (parsed.isBefore(moment().subtract(120, 'years')))
                        return invalid('birthdate_range');
                    return parsed;
                }
            });

            ctrl.$formatters.push(function (modelValue) {
                if (!modelValue) return '';
                return modelValue.format('DD/MM/YYYY');
            });
        }
    };
}]);
